<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />

  <p-card>
    <ng-template #title>
      <h1>
        {{
          isEditMode()
            ? ('controlPoints.controlPoints.edit' | translate)
            : ('controlPoints.controlPoints.add' | translate)
        }}
      </h1>
    </ng-template>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
      <div class="flex flex-col">
        <label for="cp-name" class="text-sm mb-1">
          {{ 'controlPoints.controlPoints.fields.name' | translate }}
        </label>
        <input id="cp-name" pInputText formControlName="name" [maxlength]="255" />
        @if (form.get('name')?.touched && form.get('name')?.invalid) {
          <small class="text-red-500 mt-1">
            {{ 'validation.required' | translate }}
          </small>
        }
      </div>

      <div class="flex flex-col">
        <label for="cp-description" class="text-sm mb-1">
          {{ 'controlPoints.controlPoints.fields.description' | translate }}
        </label>
        <textarea
          id="cp-description"
          pTextarea
          formControlName="description"
          rows="3"
          class="w-full"
        ></textarea>
      </div>

      <div class="flex flex-col">
        <label for="cp-interval" class="text-sm mb-1">
          {{ 'controlPoints.controlPoints.fields.intervalMinutes' | translate }}
        </label>
        <p-inputnumber
          inputId="cp-interval"
          formControlName="interval_minutes"
          [min]="1"
          [max]="480"
          [showButtons]="true"
          [useGrouping]="false"
          suffix=" min"
          styleClass="w-full"
        />
        <small class="text-color-secondary mt-1">
          {{
            'controlPoints.controlPoints.fields.intervalMinutesHint' | translate
          }}
        </small>
        @if (
          form.get('interval_minutes')?.touched &&
          form.get('interval_minutes')?.invalid
        ) {
          <small class="text-red-500 mt-1">
            {{
              'controlPoints.controlPoints.fields.intervalMinutesRange'
                | translate
            }}
          </small>
        }
      </div>

      <div class="flex flex-col">
        <label for="cp-tag" class="text-sm mb-1">
          {{ 'controlPoints.controlPoints.fields.tagName' | translate }}
        </label>
        <input
          id="cp-tag"
          pInputText
          formControlName="tag_name"
          [maxlength]="255"
          class="font-mono"
        />
        <small class="text-color-secondary mt-1">
          {{ 'controlPoints.controlPoints.fields.tagNameHint' | translate }}
        </small>
        @if (form.get('tag_name')?.touched && form.get('tag_name')?.invalid) {
          <small class="text-red-500 mt-1">
            {{ 'validation.required' | translate }}
          </small>
        }
        @if (form.get('tag_name')?.errors?.['server']) {
          <small class="text-red-500 mt-1">
            {{ form.get('tag_name')?.errors?.['server']?.message }}
          </small>
        }
      </div>

      <div class="flex flex-col">
        <label for="cp-qualifications" class="text-sm mb-1">
          {{ 'controlPoints.controlPoints.fields.qualifications' | translate }}
        </label>
        <p-multiselect
          inputId="cp-qualifications"
          formControlName="qualification_ids"
          [options]="qualificationService.items()"
          optionLabel="name"
          optionValue="id"
          [filter]="true"
          filterBy="name"
          display="chip"
          appendTo="body"
          styleClass="w-full"
          [placeholder]="
            'controlPoints.controlPoints.fields.qualificationsPlaceholder'
              | translate
          "
        />
        <small class="text-color-secondary mt-1">
          {{
            'controlPoints.controlPoints.fields.qualificationsHint' | translate
          }}
        </small>
      </div>

      <div class="flex justify-between items-center pt-2">
        <p-button
          type="button"
          severity="secondary"
          [label]="'label.cancel' | translate"
          (onClick)="onCancel()"
        />
        <div class="flex gap-2">
          @if (isEditMode() && model()) {
            <p-button
              type="button"
              severity="danger"
              icon="fa fa-trash"
              [label]="'label.delete' | translate"
              (onClick)="onDelete($event)"
            />
          }
          <p-button
            type="submit"
            [label]="'label.save' | translate"
            [loading]="submitting()"
          />
        </div>
      </div>
    </form>
  </p-card>
</div>
